// extracted by mini-css-extract-plugin
module.exports = {"loaderFixedContainer":"Loader_loaderFixedContainer__-E3QZ","loadingAnimation":"Loader_loadingAnimation__2gWuk","loading-animation":"Loader_loading-animation__246vm"};